/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Benefits_HeadingInputs */

const ja_playdata_home_benefits_heading = /** @type {(inputs: Playdata_Home_Benefits_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eスポーツチーム・ブランド・大会運営者の皆様へ`)
};

const en_playdata_home_benefits_heading = /** @type {(inputs: Playdata_Home_Benefits_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For Esports Teams, Brands and Tournament Organisers`)
};

/**
* | output |
* | --- |
* | "For Esports Teams, Brands and Tournament Organisers" |
*
* @param {Playdata_Home_Benefits_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_benefits_heading = /** @type {((inputs?: Playdata_Home_Benefits_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Benefits_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_benefits_heading(inputs)
	return en_playdata_home_benefits_heading(inputs)
});